import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import onePdf from '../assets/pdf/one.pdf';
import twoPdf from '../assets/pdf/two.pdf';
import threePdf from '../assets/pdf/three.pdf';
import threeImage from '../assets/pdf/three.jpeg';

// Optional: thumbnail images for one.pdf and two.pdf
import oneThumb from '../assets/pdf/one.jpg'; // create/export thumbnail
import twoThumb from '../assets/pdf/two.jpg'; // create/export thumbnail

function PdfViewerPage() {
  const pdfs = [
    {
      name: 'IR Imaging: A New Approach for Breast Cancer Detection',
      file: onePdf,
      thumbnail: oneThumb,
    },
    {
      name: 'Thermal Imaging for Breast Cancer Detection: A Controversy',
      file: twoPdf,
      thumbnail: twoThumb,
    },
    {
      name: 'Advance in Data Driven Computing and Intelligent System',
      file: threePdf,
      thumbnail: threeImage,
    },
  ];

  const openPdfInNewTab = (pdfFile) => {
    window.open(pdfFile, '_blank');
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Our International Publications</h2>
      <div className="why-thermal-line"></div>
      <div className="row">
        {pdfs.map((pdf, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <button
              className="list-group-item list-group-item-action"
              onClick={() => openPdfInNewTab(pdf.file)}
              style={{
                textAlign: 'center',
                padding: '0',
                border: 'none',
                background: 'none',
              }}
            >
              <h5 style={{ padding: '10px' }}>{pdf.name}</h5>
              <div className="thumbnail-container" style={{ width: '100%' }}>
                <img
                  src={pdf.thumbnail}
                  alt={pdf.name}
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                  }}
                />
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PdfViewerPage;
